import React from 'react';
import DashboardLayout from '../../components/DashboardLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { FileText } from 'lucide-react';

const Exams = () => {
    return (
        <DashboardLayout>
            <div className="space-y-6" data-testid="exams-page">
                <div>
                    <h1 className="text-2xl font-bold text-[#1F2937] font-['Outfit']">Exams</h1>
                    <p className="text-[#4B5563]">Manage exams</p>
                </div>
                <Card className="card-surface">
                    <CardContent className="flex flex-col items-center justify-center py-16">
                        <FileText className="h-16 w-16 text-[#4B5563]/30 mb-4" />
                        <p className="text-[#4B5563] text-lg">Exams page coming soon</p>
                    </CardContent>
                </Card>
            </div>
        </DashboardLayout>
    );
};

export default Exams;
